const MAX_PAGE_COUNT = 300;

const getPageCount = (listingsCount: number, listingsPerPage: number): number => {
  const totalPages = Math.ceil(listingsCount / listingsPerPage);
  return Math.min(totalPages, MAX_PAGE_COUNT);
};

export default getPageCount;
